'use client';
import React, { useState } from 'react';
import dynamic from 'next/dynamic';

const ThreatTrendChart = dynamic(() => import('./ThreatTrendChart'), { ssr: false });
const RegionalRiskChart = dynamic(() => import('./RegionalRiskChart'), { ssr: false });

const timeRanges = [
  { id: 'range-7d', label: '7D' },
  { id: 'range-14d', label: '14D' },
  { id: 'range-30d', label: '30D' },
  { id: 'range-90d', label: '90D' },
];

export default function ChartsRow() {
  const [activeRange, setActiveRange] = useState('range-14d');

  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 gap-4">
      {/* Threat trend — wider */}
      <div className="lg:col-span-3 card-elevated rounded-xl p-5 border border-border">
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-sm font-semibold text-foreground">Global Threat Index Trend</p>
            <p className="text-xs text-muted-foreground">AI-composite score across all risk categories</p>
          </div>
          <div className="flex items-center gap-1 bg-muted rounded-md p-0.5">
            {timeRanges?.map((range) => (
              <button
                key={range?.id}
                onClick={() => setActiveRange(range?.id)}
                className={`px-2.5 py-1 text-xs font-medium rounded transition-all duration-150 ${
                  activeRange === range?.id
                    ? 'bg-card text-foreground shadow-sm'
                    : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                {range?.label}
              </button>
            ))}
          </div>
        </div>
        <ThreatTrendChart />
      </div>
      {/* Regional risk — narrower */}
      <div className="lg:col-span-2 card-elevated rounded-xl p-5 border border-border">
        <div className="mb-4">
          <p className="text-sm font-semibold text-foreground">Risk by Region</p>
          <p className="text-xs text-muted-foreground">Current composite volatility score</p>
        </div>
        <RegionalRiskChart />
      </div>
    </div>
  );
}